import styled from 'styled-components';

const AuthForm = styled.form`
  width: 400px;
  margin: 75px auto 0;
`;

export { AuthForm };
